import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SchemaOrg from '@/components/feature/SchemaOrg';
import { useSEO } from '@/hooks/useSEO';
import HeroSection from './components/HeroSection';
import HotTopicsBar from './components/HotTopicsBar';
import FeaturedArticles from './components/FeaturedArticles';
import LatestArticles from './components/LatestArticles';
import CategoryGrid from './components/CategoryGrid';

const homeSeo = {
  title: '黑料吃瓜网 | 黑料吃瓜在线观看与黑料吃瓜视频 | 91黑料吃瓜网最新入口',
  description:
    '黑料吃瓜网📢核心聚合页，聚焦91黑料吃瓜网、黑料吃瓜在线观看等热门搜索词。提供黑料吃瓜视频、⏰黑料吃瓜爆料与最新网红塌房实录，⭐24小时不打烊，点开即看独家吃瓜资源。',
  keywords:
    '91黑料吃瓜网,黑料吃瓜在线观看,黑料吃瓜视频,黑料吃瓜爆料,黑料吃瓜不打烊,黑料吃瓜入口,黑料吃瓜最新地址,黑料吃瓜官网,网红黑料吃瓜视频',
  canonical: 'https://www.heiliaochigua.com',
};

export default function Home() {
  useSEO(homeSeo);

  return (
    <>
      <SchemaOrg type="Organization" />
      <SchemaOrg type="WebSite" />
      <SchemaOrg
        type="WebPage"
        data={{
          name: '黑料吃瓜网 - 首页',
          description: homeSeo.description,
          url: homeSeo.canonical,
        }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <article>
            <HeroSection />
          </article>
          <HotTopicsBar />
          <FeaturedArticles />
          <LatestArticles />
          <CategoryGrid />
        </main>
        <Footer />
      </div>
    </>
  );
}